const EVENT = 'nyhetslanseringar:open-alcohol-info';

export function openAlcoholInfo(productId: string): void {
  window.dispatchEvent(new CustomEvent<string>(EVENT, { detail: productId }));
}

export function onOpenAlcoholInfo(listener: (productId: string) => void): () => void {
  const handler = (event: Event) => {
    const id = (event as CustomEvent<string>).detail;
    if (typeof id === 'string' && id) listener(id);
  };
  window.addEventListener(EVENT, handler);
  return () => window.removeEventListener(EVENT, handler);
}
